import React from "react";
import HEXThumbsUp from "@icons/hexpert/HEXThumbsUp";
import './ProductIntro.scss';

export type HexpertIntroBlockProps = {
  title?: string;
  description?: string;
  email?: string; //@TODO
  quoteText?: string;
  quoteQuestion?: string;
  onClick: () => void;
};

export const ProductIntro = ({
  title,
  description,
  email,
  quoteText,
  quoteQuestion,
  onClick,
}: HexpertIntroBlockProps) => {
  const url = window?.location?.protocol + "//" + window?.location?.hostname;
  return (
    <>
      <div className="c-hex-result-product-intro">
        <div className="c-hex-result-product-intro-section">
          <h2 className="c-hex-result-product-intro-title">{title}</h2>
          <p className="c-hex-result-product-intro-body">{description}</p>
          {email && (
            <div
              onClick={onClick}
              className="c-hex-result-product-intro-contact-link"
            >
              {email}
            </div>
          )}
        </div>
      </div>
      <div className="c-hex-result-product-quote">
        <span>
          <HEXThumbsUp />
        </span>
        <p className="c-hex-result-product-quote-text">
          <span>{quoteQuestion}</span>
        </p>
        <div onClick={onClick} className="c-hex-result-product-quote-link">
          {quoteText}
        </div>
      </div>
    </>
  );
};
